<template>
  <div class="row">
    <div class="col-lg-12" v-if="result">
      <table class="table table-hover table-striped">
        <thead>
        <tr>
          <th></th>
          <th>Keyword</th>
          <th class="center" v-tooltip="'Keyword position for target'">Pos</th>
          <th class="center">Overlap</th>
          <th>Url</th>
          <th>Weight</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(kw, i) in result.data.overlaps" :key="'result-' + i"
            :class="kw.targetUrl === result.payload.url ? 'green' : (kw.targetUrl === false ? 'red' : 'orange')">
          <td>{{ i + 1 }}</td>
          <td>{{ kw.keyword }}</td>
          <td class="center">{{ kw.targetRank || '?' }}</td>
          <td class="center">{{ kw.count }}</td>
          <td :title="kw.targetUrl">
            {{ shorten(kw.targetUrl, 50, '') }}
            <i class="fa fa-remove red" v-if="kw.targetUrl === false"></i>
            <i class="fa fa-clock orange" v-else-if="kw.targetUrl === null"></i>
            <a :href="kw.targetUrl" target="_blank" v-else> <i class="fa fa-external-link"></i></a>
          </td>
          <td>{{ kw.weight }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { String } from '../../../../../../mixins/helperMixin'

export default {
  props: ['result'],
  mixins: [String]
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/PageEntity/Keywords.vue